import { Box } from '@material-ui/core';
import { getAgentById } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router';

import { Configuration } from '@/components/modules/AgentDetail/AgentDetails/components/Configuration/Configuration';
import { Details } from '@/components/modules/AgentDetail/AgentDetails/components/Details';
import { ModuleCorePermissionProps } from '@/config/types';
import { useCache } from '@/hooks/requests/useCache';
import { useSetPageLoadingWhenRequesting } from '@/hooks/requests/useSetPageLoadingWhenRequesting';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const AgentDetails = ({ canEdit = false }: ModuleCorePermissionProps) => {
  const { agentId } = useParams();

  if (!agentId) return <></>;

  const { data: agent, loading } = useCache(getAgentById, { agentId });

  useSetPageLoadingWhenRequesting('AGENT', [loading]);

  if (!agent) {
    return null;
  }

  return (
    <>
      <Details currentAgent={agent} />
      <Box mt={3} />
      <Configuration editModeAllowed={canEdit} currentAgent={agent} />
    </>
  );
};

export const AgentDetailsModule = withPermissionsModule(AgentDetails);
